import React from 'react';

import { COLORS } from '@clutter/clean';

import { DEFAULT_MAP_STYLE, MapProvider } from '@shared/map/context';
import { Geom, type GeomGeoJSON } from '@shared/map/geom';
import { Polygon } from '@shared/map/polygon';

import type { MapOptions } from 'google-map-react';

const MAP_OPTIONS: MapOptions = {
  styles: DEFAULT_MAP_STYLE,
  zoomControl: true,
};

const POLYGON_OPTIONS: google.maps.PolygonOptions = {
  fillColor: COLORS.tealPrimary,
  strokeColor: COLORS.tealBrand,
};

const Map: React.FC<{
  center: {
    lat: number;
    lng: number;
  };
  geom?: GeomGeoJSON; // GeoJSON
  polygons?: ReadonlyArray<{
    paths: ReadonlyArray<
      ReadonlyArray<{
        lat: number;
        lng: number;
      }>
    >;
  }>;
}> = ({ center, geom, polygons }) => (
  <MapProvider.Map center={center} options={MAP_OPTIONS} defaultZoom={9}>
    {polygons?.map((p, i) => (
      <Polygon key={i} polygon={p.paths} options={POLYGON_OPTIONS} />
    ))}
    {geom && <Geom geom={geom} options={POLYGON_OPTIONS} />}
  </MapProvider.Map>
);

const MapWithProvider: React.FC<React.ComponentProps<typeof Map>> = (props) => (
  <MapProvider includeMapComponent={false}>
    <Map {...props} />
  </MapProvider>
);

export { MapWithProvider as Map };
